// dicionario em: SELECT * FROM lista_logs;
module.exports = {
}
